import React, { useState } from 'react';

import { gql } from 'apollo-boost';
import { useMutation } from '@apollo/react-hooks';
import './fatcaPopup.scss';
import './checkbox.scss';
import Checkbox from '../Form/Checkbox/Checkbox';
import Modal from '../Modal/Modal';
import Button, {LoadingButton} from '../Form/Button/Button';
import chevDownSlim from '../../assets/images/chev-down-slim.svg';
import chevUp from '../../assets/images/chev-up.svg';

/** @import {FatcaPopupProps} from './FatcaPopupTypes' */

const SAVE_FATCA = gql`
    mutation SaveFatca($request : SaveFatcaRequestType!){
        saveFatca(request:$request) {
          success
        }
    }  
  `;

function FatcaPopup(/** @type {FatcaPopupProps} */ props) {
  const [fatcaResponse, setFatcaResponse] = useState('');
  const [showInfo, setShowInfo] = useState(false);
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [saveFatca] = useMutation(SAVE_FATCA);

  const submitResponse = async () => {
    setIsLoading(true);
    var result = await saveFatca({
      variables: {
        request: {
          usCitizen: fatcaResponse === "yes"
        }
      }
    });

    setIsLoading(false);

    if (result && result.data && result.data.saveFatca && result.data.saveFatca.success) {
      setStep(2);
    }
    else {
      setStep(2);
    }
  }

  const renderSubmitButton = () => {
    if (isLoading) {
      return (
          <LoadingButton customClassNames={['']} />
      )
    }

    return (
        <Button size='med'
            label="Submit"
            disabled={!fatcaResponse}
            onClick={submitResponse}
        />
    );
  };

  const renderStepOne = () => {
    return (
        <>
          <h2 className="fatca__title">Before you continue, are you a US citizen?</h2>
          <a className="fatca__content fatca__content-grey">In case you're not sure: <br />You're a US citizen if, by place of birth, naturalization or the nationality of one or both of your parents, you've been granted full rights and responsibilities as a member of a nation or political community in the United States.</a>
          {!showInfo ?
              <span className="fatca__dropdown" ><a
                  className="fatca__content fatca__content-blue"
                  onClick={() => setShowInfo(!showInfo)}> Why are you asking me this? 
      </a>
        <img
            className="fatca__chev"
            src={chevDownSlim}
            onClick={() => setShowInfo(!showInfo)}/>
      </span>
              : <span className="fatca__dropdown" ><a
                  className="fatca__content fatca__content-blue"
                  onClick={() => setShowInfo(!showInfo)}> Why are you asking me this? 
      </a>
        <img
            className="fatca__chev"
            src={chevUp}
            onClick={() => setShowInfo(!showInfo)}/>
      </span>}
          {showInfo && <a className="fatca__content fatca__content-grey fatca__space">We need this extra piece of information to make sure we’re meeting all the requirements the regulators set out for us. We’re available via live chat if you’d like more information.</a>}
          <div className="fatca__space">
            <Checkbox
                label="Yes I'm a US citizen"
                onChange={() => setFatcaResponse("yes")}
                checked={fatcaResponse === "yes"}
            />
          </div>
          <div>
            <Checkbox
                label="No, I'm not a US citizen"
                onChange={() => setFatcaResponse("no")}
                checked={fatcaResponse === "no"}
            />
          </div>
          <div className="fatca__button-container">
            {renderSubmitButton()}
          </div>
        </>
    )
  }

  const renderStepTwo = () => {
    return (
        <>
          <div>
            <h2 className="fatca__subtitle">Thank you</h2>
            <p className="fatca__content-two">You can carry on to your account as usual. If we do need to follow up, we'll contact you soon.</p>
            <div className="fatca__button">
              <Button size='med'
                  label='OK'
                  onClick={() => props.closePopup()}
              />
            </div>
          </div>
        </>
    )
  };

  return (
      <Modal className="fatca fatca__fixed-height" hideClose={true}>
        {step === 1 ? renderStepOne() : renderStepTwo()}
      </Modal>
  );
}

export default FatcaPopup;
